import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { Person } from "src/app/shared/Models/read";
import { FormControl } from "@angular/forms";
import { OutsideSurveyService } from "src/app/shared/services/outside-survey.service";
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  takeUntil,
} from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "app-document-contact-search",
  templateUrl: "./document-contact-search.component.html",
  styleUrls: ["./document-contact-search.component.scss"],
})
export class DocumentContactSearchComponent implements OnInit, OnDestroy {
  searchInputFocus: boolean;
  searchResults: Person[];
  searchInput: FormControl = new FormControl();
  selectedContact: Person;
  @Output() selectResult = new EventEmitter<any>();
  @Output() newContact = new EventEmitter<any>();

  constructor(private outsideSurveyService: OutsideSurveyService) {}

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnInit() {
    this.searchInput.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap((query) =>
          query.length < 1
            ? (this.searchResults = [])
            : this.outsideSurveyService.searchContacts(query)
        )
      )
      .subscribe((res: any) => {
        this.searchResults = res;
      });
  }

  onSelectResult(searchResult) {
    this.searchInput.setValue("");
    this.selectedContact = searchResult;
    this.selectResult.emit(this.selectedContact);
    this.searchInputFocus = false;
    this.searchResults = [];
  }

  isFocus(bool: boolean) {
    setTimeout(() => {
      // without this click event on search result don't get fired.
      this.searchInputFocus = bool;
    }, 150);
  }

  onAddNewContact() {
    this.onSelectResult(null);
    this.newContact.emit();
  }
}
